
import store from '@/core/store'
import { AmplifyService } from '@/app-domains/user/auth/providers/Amplify.service'
import NotificationsService from '@/app-domains/user/session/notifications/NotificationService'
import { Auth } from 'aws-amplify'
import { hasTokenAvailable } from '@/core/http/auth.api'
import { setLogged } from '@/core/store/Slices/MeSlice'
import { getMinutesBetweenDates } from '@/helpers/time'
import commonsService from '@/services/commons.service'
import sessionService from '@/app-domains/user/session/session.service'
import log from '@/services/log.service'
import messagesService from '@/app-domains/messages/messages.service'
import ToastService from '@/components/Toast/Toast.service'

const MINUTES_TO_REFRESH = commonsService.isMobile() ? 5 : 1
class AuthService {
  constructor () {
    this.isLogged = false
    this.timeToRefresh = 60000
    this.activeSessionPolling = 20000
    this.timeWhenFocusLost = null
    this.interval = () => {}
    this.refreshEntitiesInterval = () => {}
  }

  async init () {
    log.marKNow('INIT APP')
    AmplifyService.configure()
    await AmplifyService.fetchCredentials()
    this.setUserLogged()
    if (!this.isLogged) {
      const path = commonsService.history.location.pathname
      if (!path.includes('auth') || path.includes('domain-selection') || path.includes('auth/signup/waiting-page')) {
        store.commit('APP:is_loading', false)
        commonsService.goToPage('/auth')
      }
    } else {
      this.setIntervalForCheckSession()
      this.setIntervalForRefreshEntities()
      this.checkSessionWhenFocusTab()
    }
    store.commit('APP:inited')
    if (commonsService.history.location.pathname.includes('auth')) store.commit('APP:is_loading', false)
  }

  setUserLogged () {
    this.isLogged = hasTokenAvailable()
    // Checking if there's an status change on the logged user.
    if (store.getState().me.logged !== this.isLogged) {
      store.dispatch(setLogged({ logged: this.isLogged }))
      store.commit('USER:logged', this.isLogged)
    }
  }

  signIn (email, password) {
    return Auth.signIn(email, password)
  }

  async signOut () {
    try {
      Auth.signOut() // There was an await here before
      // history.push('/auth')
      commonsService.removeStorageAndRefresh()
    } catch (error) {
      commonsService.removeStorageAndRefresh()
      window.location.reload()
    }
  }

  checkIfSessionStillActive () {
    AmplifyService.refreshCredentials()
      .then(() => {
        setTimeout(() => {
          this.setUserLogged()
          NotificationsService.resetProvider()
        }, 500)
      })
      .catch(() => {
        this.isLogged = false
        store.dispatch(setLogged({ logged: this.isLogged }))
        store.commit('TOPBAR:USER_CREDENTIALS_EXPIRED')
      })
  }

  setIntervalForCheckSession () {
    this.interval = setInterval(() => this.checkIfSessionStillActive(), this.activeSessionPolling)
  }

  setIntervalForRefreshEntities () {
    this.refreshEntitiesInterval = setInterval(() => sessionService.setInitialData(), this.timeToRefresh)
  }

  async checkSessionWhenFocusTab () {
    document.addEventListener('visibilitychange', async () => {
      if (document.visibilityState === 'hidden') {
        messagesService.setLoadedMessagesCountBeforeHidingUI()
        this.timeWhenFocusLost = new Date()
      } else if (document.visibilityState === 'visible' && this.timeWhenFocusLost) {
        const minutes = getMinutesBetweenDates(this.timeWhenFocusLost, new Date())
        if (minutes > MINUTES_TO_REFRESH) {
          await sessionService.setInitialData()
          
          // Change this for threads
          const messagesBeforeRefresh = store.getState().messages.messagesCountBeforeHidingUI
          const messagesAfterRefresh = store.getState().messages.messagesCount
          
          if (messagesAfterRefresh > messagesBeforeRefresh) {
            ToastService.show({
              type: 'info',
              title: 'You have new messages!',
              message: 'Click here to scroll to the top of the feed',
              onClick: () => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
              },
              duration: 10000,
            })
          }
        }
      } else {
        this.timeWhenFocusLost = new Date()
      }
    })
  }

  doesBrowserHaveCognitoCredsStored () {
    const items = { ...window.localStorage }
    for (const item in items) {
      if (/CognitoIdentityServiceProvider\..*\./.test(item)) { return true }
    }
    return false
  }
}

export default new AuthService()
